export enum Source {
  SendMessage = 'SendMessage',
  MailComposer = 'MailComposer',
}
